export const DESTINATION = 'Destination';
export const HABIT = 'Habit';
export const KPI = 'KPI';
export const DESTINATION_INDEX = 0;
export const HABIT_INDEX = 1;
export const KPI_INDEX = 2;



// WEBPACK FOOTER //
// ./src/components/kpiPlanning/constants.js